<template>
  <main data-test="page" class="relative focus:outline-none">
    <slot></slot>
  </main>
</template>
